<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',

}

</script>

<style>
html {
  background-color: rgb(233, 233, 233);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

button{
  background-color: #578FCA
}

button {
    background-color: #143D60; /* Exemple de couleur personnalisée */
    color: white; /* texte en blanc */
    border: none; /* retire la bordure si tu veux */
}

.btn-custom:hover {
    background-color: #C0392B; /* change la couleur au survol */
}

table{
  table-layout: auto ;
  width: 100%;
}

thead tr th{
  padding-left: 10px;
  border: 1px solid rgb(230, 228, 228);
  min-height: 100px;
  min-width: 100px;
  background-color: rgba(237, 87, 62, 1);
}

tbody tr td{
  padding-left: 10px;
  border: 1px solid rgb(230, 228, 228);
  min-height: 100px;
  min-width: 100px;
}

tbody tr{
  padding: 15px;
}

tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tfoot tr td{
  padding-left: 10px;
  border: 1px solid #cfcfcf;
  min-height: 100px;
  min-width: 150px;
  background-color: #e1e1e1;

}

.tab_outils {
    display: flex;
    justify-content: flex-end;
    margin: 0;
}

.h3_remove{
    display: flex;
    justify-content: space-between;
}

.cadre{
  padding: 15px 15px 15px 15px;
  background: rgb(255, 255, 255);
  border-width:2px;
  border-style:solid;
  border-color:rgb(222, 226, 230);
  border-radius: 7px;
  min-height: 100px;
  min-width: 800px;
}

.pagination {
    display: flex;
    justify-content: center;
}

.pagination a {

    padding: 5px 10px;

}

.pagination span {
    line-height: 2.1;
}

.modal-header {
    display: flex;
    justify-content: space-between;
}

</style>
